import {
  SET_PRODUCTION_STATISTICS_FOR_AGENCY_FULL,
  SET_PRODUCTION_STATISTICS_FOR_AGENCY_FULL_ERROR,
  CLEAR_PRODUCITON_STATISTICS_FOR_AGENCY_FULL,
  PRODUCTION_STATISTICS_FOR_AGENCY_FULL_LOADING,
  SET_PRODUCTION_STATISTICS_FOR_AGENCY_FULL_FILTER_MODEL,
  CLEAR_PRODUCTION_STATISTICS_FOR_AGENCY_FULL_FILTER_MODEL,
} from "../../constants/action-types";

const initState = {
  dataSummary: [],
  isLoading: false,
  filterModel: {
    items: [],
  },
};

export const productionStatisticsForAgencyFull = (
  state = initState,
  { type, payload }
) => {
  switch (type) {
    case SET_PRODUCTION_STATISTICS_FOR_AGENCY_FULL:
      return { ...state, dataSummary: payload };
    case SET_PRODUCTION_STATISTICS_FOR_AGENCY_FULL_ERROR:
      return { ...state, loadingError: payload };
    case CLEAR_PRODUCITON_STATISTICS_FOR_AGENCY_FULL:
      return { ...state, dataSummary: [] };
    case PRODUCTION_STATISTICS_FOR_AGENCY_FULL_LOADING:
      return { ...state, isLoading: payload };
    case SET_PRODUCTION_STATISTICS_FOR_AGENCY_FULL_FILTER_MODEL:
      return { ...state, filterModel: payload };
    case CLEAR_PRODUCTION_STATISTICS_FOR_AGENCY_FULL_FILTER_MODEL:
      return {
        ...state,
        filterModel: {
          items: [],
        },
      };
    default:
      return state;
  }
};
